import { useMemo } from "react";
import { Navigate } from "react-big-calendar";
import TimeGrid from "react-big-calendar/lib/TimeGrid";
import * as dates from "date-arithmetic";

export const MyWeek = ({
  date,
  localizer,
  max = localizer.endOf(new Date(), "day"),
  min = localizer.startOf(new Date(), "day"),
  scrollToTime = localizer.startOf(new Date(), "day"),
  ...props
}) => {
  const currRange = useMemo(
    () => MyWeek.range(date, { localizer }),
    [date, localizer]
  );

  return (
    <TimeGrid
      date={date}
      eventOffset={15}
      localizer={localizer}
      max={max}
      min={min}
      range={currRange}
      scrollToTime={scrollToTime}
      {...props}
    />
  );
};

MyWeek.range = (date, { localizer }) => {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);

  const end = dates.add(start, window.innerWidth < 768 ? 1 : 6, "day");

  let current = start;
  const range = [];

  while (localizer.lte(current, end, "day")) {
    range.push(current);
    current = localizer.add(current, 1, "day");
  }

  return range;
};

// MyWeek.range = (date, { localizer }) => {
//   const start = date;
//   const end = dates.add(start, 2, "day");

//   let current = start;
//   const range = [];

//   while (localizer.lte(current, end, "day")) {
//     range.push(current);
//     current = localizer.add(current, 1, "day");
//   }

//   return range;
// };

MyWeek.navigate = (date, action, { localizer }) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return localizer.add(date, window.innerWidth < 768 ? -2 : -7, "day");

    case Navigate.NEXT:
      return localizer.add(date, window.innerWidth < 768 ? 2 : 7, "day");

    default:
      return date;
  }
};

// MyWeek.navigate = (date, action, { localizer }) => {
//   switch (action) {
//     case Navigate.PREVIOUS:
//       return localizer.add(date, -3, "day");

//     case Navigate.NEXT:
//       return localizer.add(date, 3, "day");

//     default:
//       return date;
//   }
// };

MyWeek.title = (date) => {
  const startDate = new Date(date);
  const endDate = new Date(date);
  const daysToAdd = window.innerWidth < 768 ? 1 : 6;

  // endDate.setDate(startDate.getDate() + window.innerWidth < 768 ? 1 : 6);
  endDate.setDate(startDate.getDate() + daysToAdd);

  const startString = startDate.toLocaleDateString();
  const endString = endDate.toLocaleDateString();

  return `Mi semana: ${startString} - ${endString}`;
};
